<template>
<div class="flex flex-col bg-white rounded-lg">
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
      <div class="shadow overflow-y-auto border-b border-gray-200 sm:rounded-lg rounded-lg scrollbar-w-2 scrollbar-track-gray-lighter scrollbar-thumb-rounded scrollbar-thumb-gray h-96 max-h-full">
        <table class="min-w-full divide-y divide-gray-200 table-collapse">
          <thead>
            <tr>
              <template v-for="header in headers">
                <th v-bind:key="header.tag" class="z-20 sticky top-0 px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-700 uppercase tracking-wider">
                  {{header.title}}
                </th>
              </template>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200 w-full">
            <template v-for="node in datalist" >
              <transition name="fade"  v-bind:key="node.type + node.devid">
                <tree-data-table-row v-if="node.level === 0 || openparents.includes(node.parentid)" v-bind:key="node.type + node.devid" :node="node" :level="node.level" :parentid="node.parentid" :headers="headers"/>
              </transition>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import TreeDataTableRow from "./TreeDataTableRow";

export default {
  name: "p-treedatatable",
  components: { TreeDataTableRow },
  props: {
    items: {
      type: Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      level: 0,
      datalist: [],
      openparents: [],
      nestedchildren: [],
    }
  },
  watch: {
    items(newlist) {
      this.datalist = []
      console.log('flat', newlist);
      this.flat(newlist, 0);
    }
  },
  methods: {
    flat(branch, level) {
      branch.map((node) => {
        node.level = level
        this.datalist.push(node)
        if (node.children && node.children.length) {
          node.children.map((obj) => obj.parentid = node.devid)
          this.flat(node.children, level + 1)
        }
      })
    },
    getChildren(node) {
      if (!this.nestedchildren.includes(node.parentid)) {
        this.nestedchildren.push(node.parentid)
      }
      if (node.children && node.children.length) {
        node.children.map((obj) => {
          this.getChildren(obj)
        })
      }
    },
    toggleNode(node, open) {
      this.nestedchildren = []
      node.children.map(obj => this.getChildren(obj))
      if(open) {
        this.openparents.push(node.devid);
      } else {
        this.nestedchildren.map((parentid) => {
          let index = this.openparents.indexOf(parentid);
          while (index !== -1) {
            this.openparents.splice(index, 1);
            index = this.openparents.indexOf(node.devid)
          }
        })
      }
      this.$parent.toggleNode(node, open);
    },
    onRowClicked(node) {
      this.$parent.onRowClicked(node);
    },
    onRowDblClicked(node) {
      this.$parent.onRowDblClicked(node);
    }

  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: all .2s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
